import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { packageManagementFeature, PackageManagementEffects } from './store';

export function providePackageManagementFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(packageManagementFeature),
    provideEffects(PackageManagementEffects),
  ]);
}
